
import { AddTimeEntryButton } from "@/components/AddTimeEntryButton";
import { Project } from "@/types/Project";
import { TimeEntry } from "@/components/TimeEntryForm";

interface ProjectsHeaderProps {
  hasProjects: boolean;
  onCreateNewProject: () => void;
  projects?: Project[];
  onAddTimeEntry?: (entry: TimeEntry) => void;
}

export function ProjectsHeader({ 
  hasProjects, 
  onCreateNewProject, 
  projects = [],
  onAddTimeEntry
}: ProjectsHeaderProps) {
  return (
    <div className="flex justify-between items-center">
      <div className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Projects</h1>
        <p className="text-muted-foreground">
          Manage your projects and track time against them.
        </p>
      </div>
      <div className="flex gap-2">
        <AddTimeEntryButton 
          hasProjects={hasProjects} 
          onCreateProject={onCreateNewProject}
          projects={projects}
          onAddTimeEntry={onAddTimeEntry}
        />
      </div>
    </div>
  );
}
